import { getCurrencySymbol } from '@angular/common';
import { LOCALES } from 'mt-shared';

export enum CURRENCY_CODES {
  USD = 'USD',
  CAD = 'CAD',
  EUR = 'EUR',
  BGN = 'BGN',
  DKK = 'DKK',
  CHF = 'CHF',
  MXN = 'MXN',
}

export const NA_CURRENCY_CODES = ['USD', 'CAD', 'MXN'];

export enum COUNTRY_CODES {
  US = 'US',
  CA = 'CA',
}

// TODO: Change the value 'en' when needed for other locales based on product's feedback
export const LOCALE_CURRENCY_MAP: Record<LOCALES, string> = {
  [LOCALES.FRENCH]: 'en',
  [LOCALES.ENGLISH]: 'en',
  [LOCALES.SPANISH]: 'en',
}

export const DEFAULT_CURRENCY_SYMBOL: string = '$';
export const DEFAULT_CURRENCY_FORMAT: string = '1.2-2';
export const DEFAULT_COUNTRY_CODE: COUNTRY_CODES = COUNTRY_CODES.US;
export const DEFAULT_CURRENCY_CODE: CURRENCY_CODES = CURRENCY_CODES.USD;
export const DEFAULT_CURRENCY_LOCALE: string = LOCALE_CURRENCY_MAP[LOCALES.ENGLISH];

export const CountryToCurrencyMap: Record<COUNTRY_CODES, CURRENCY_CODES> = {
  [COUNTRY_CODES.US]: CURRENCY_CODES.USD,
  [COUNTRY_CODES.CA]: CURRENCY_CODES.CAD,
}

export function getNarrowCurrencySymbol(currencyCode: string): string {
  return getCurrencySymbol(currencyCode, 'narrow');
}

export function getWideCurrencySymbol(currencyCode: string): string {
  return getCurrencySymbol(currencyCode, 'wide');
}